import { render, staticRenderFns } from "./comBrand.vue?vue&type=template&id=1b245712&scoped=true"
import script from "./comBrand.vue?vue&type=script&lang=js"
export * from "./comBrand.vue?vue&type=script&lang=js"
import style0 from "./comBrand.vue?vue&type=style&index=0&id=1b245712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b245712",
  null
  
)

export default component.exports